import React from 'react'
import { ITemplateQuestionGroup } from '@core/entities/template/TemplateQuestionGroup'
import { QuestionGroupProps } from '@core/components/templateAnswersForm'
import { ImageWarning } from '@core/entities/ImageWarning'
import { VirtualizedQuestionGroupList } from './VirtualizedQuestionGroupList'

type ComponentType = {
  // Plain answers array — read-only surfaces have no react-hook-form context
  questions: Array<ITemplateQuestionGroup>
  organisationId?: number
  projectId?: number
  permitId?: number
  warnings?: Array<ImageWarning>
  onlyShowWarnings?: boolean
  submittedBy?: QuestionGroupProps['submittedBy']
}

// Read-only virtualized answers list — one Virtuoso row per question group.
export const VirtualizedTemplateAnswers: React.FC<ComponentType> = ({
  questions,
  organisationId,
  projectId,
  permitId,
  warnings,
  onlyShowWarnings,
  submittedBy,
}) => {
  return (
    <VirtualizedQuestionGroupList
      questionGroups={questions}
      organisationId={organisationId}
      projectId={projectId}
      permitId={permitId}
      warnings={warnings}
      onlyShowWarnings={onlyShowWarnings}
      submittedBy={submittedBy}
      readOnly
    />
  )
}
